import { Button, IconButton, Tooltip } from '@mui/material';
import styles from './ActionButtons.module.scss';
import AISummaryIcon from '../../../../../static/assets/svg/list_alt_check.svg';
import FileSaveIcon from '../../../../../static/assets/svg/file_save.svg';
import EditContractIcon from '../../../../../static/assets/svg/contract_edit.svg';
import BrushIcon from '../../../../../static/assets/svg/brush.svg';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ActionButtonsProps } from './types';
import { DocumentsEditButton } from '../../../../common/document-edit-button/DocumentsEditButton';
import { useSearchParams } from 'react-router-dom';

export const ActionButtons = ({
  handleAISummaryGeneration,
  handleDocumentDownload,
  handleSignDocument,
  handleEditDocument,
  handleCreateTemplate,
  handleDeleteDocument,
  handleSaveDocument,
  buttonSaveDisabled,
  handleCreateTemplateMainBtn,
  doc,
  creatingTemplateEnabled,
  isDocumentContentTab,
}: ActionButtonsProps) => {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const contractGenerated = params.get('contractGenerated');
  const editDocumentParam = params.get('editDocument');
  return (
    <>
      {handleCreateTemplateMainBtn && !creatingTemplateEnabled && handleCreateTemplate && (
        <Button
          type='button'
          className='btn-default btn-action-basic btn-small'
          role='button'
          variant='contained'
          disabled={!buttonSaveDisabled}
          onClick={handleCreateTemplate}
          style={{ marginRight: '8px' }}
        >
          {t('buttons.createTemplate')}
        </Button>
      )}
      {Boolean(handleSaveDocument) && !buttonSaveDisabled && isDocumentContentTab && (
        <Button
          type='button'
          className='btn-default btn-action-basic btn-small'
          role='button'
          variant='contained'
          disabled={buttonSaveDisabled}
          onClick={handleSaveDocument}
          style={{ marginRight: '8px' }}
        >
          {t('buttons.saveContent')}
        </Button>
      )}
      {(!isDocumentContentTab || buttonSaveDisabled) && (
        <Tooltip title={t('buttons.edit')} placement='top' arrow>
          <IconButton size='small' className={styles.actionButton} onClick={handleEditDocument}>
            <BrushIcon />
          </IconButton>
        </Tooltip>
      )}
      <Tooltip title={t('buttons.summary')} placement='top' arrow>
        <IconButton
          size='small'
          className={styles.actionButton}
          onClick={handleAISummaryGeneration}
        >
          <AISummaryIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title={t('buttons.download')} placement='top' arrow>
        <IconButton size='small' className={styles.actionButton} onClick={handleDocumentDownload}>
          <FileSaveIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title={t('buttons.sign')} placement='top' arrow>
        <IconButton size='small' className={styles.actionButton} onClick={handleSignDocument}>
          <EditContractIcon />
        </IconButton>
      </Tooltip>
      <DocumentsEditButton
        document={doc}
        createTemplateFn={!contractGenerated ? handleCreateTemplate : null}
        deleteDocumentFn={handleDeleteDocument}
      />
    </>
  );
};
